module.exports = __webpack_public_path__ + "img/cards2_pl.63e5339a.svg";